import React, { useCallback, useState, useEffect } from "react";

export const useSlider = ({ value, ...config }) => {
  const [sliderVal, setSliderVal] = useState(value);

  const [configuration, setConfiguration] = useState(config);

  const onChange = useCallback((val) => {
    setSliderVal(val);
  }, []);

  useEffect(() => {
    setConfiguration({
      ...config,
      onChange,
      value: sliderVal,
    });
  }, [sliderVal]);

  // console.log(configuration)
  return [sliderVal, configuration];
};

export const RangeSlider = ({
  classes,
  label,
  onChange,
  sliderVal,
  setSliderVal,
  value,
  ...sliderProps
}) => {
  // const [sliderVal, setSliderVal] = useState(0);
  const [earn, setEarn] = useState(0);
  const [roi,setRoi] = useState(0);
  const [profit,setProfit] = useState(0)


  // useEffect(() => {
  //   setSliderVal(value);
  // }, [value]);

  const changeCallback = (e) => {
    onChange(Number(e.target.value));
  };

  useEffect(() => {
    if (value === 7) {
      return setEarn(63.00),setRoi(18.00),setProfit(126);
    }
    if (value === 8) {
      return setRoi(16.38),setProfit(131),setEarn(65.6);
    }
    if (value === 9) {
      return setRoi(15.11),setProfit(136),setEarn(68.00);
    }
    if (value === 10) {
      return setRoi(14.10),setProfit(141),setEarn(70.50);
    }
    if (value === 11) {
      return setRoi(13.27),setProfit(146),setEarn(73.00);
    }
    if (value === 12) {
      return setRoi(12.58),setProfit(151),setEarn(75.50);
    }
    if (value === 13) {
      return setRoi(12.00),setProfit(156),setEarn(78.00);
    }
    if (value === 14) {
      return setRoi(11.50),setProfit(161),setEarn(80.50);
    }
    if (value === 15) {
      return setRoi(11.07),setProfit(166),setEarn(83.00);
    }
    if (value === 16) {
      return setRoi(10.69),setProfit(171),setEarn(85.50);
    }
    if (value === 17) {
      return setRoi(10.35),setProfit(176),setEarn(88.00);
    }
    if (value === 18) {
      return setRoi(10.06),setProfit(181),setEarn(90.50);
    }
    if (value === 19) {
      return setRoi(9.79),setProfit(186),setEarn(93.00);
    }
    if (value === 20) {
      return setRoi(9.55),setProfit(191),setEarn(95.50);
    }
    if (value === 21) {
      return setRoi(9.33),setProfit(196),setEarn(98.00);
    }
    if (value === 22) {
      return setRoi(9.14),setProfit(201),setEarn(100.50);
    }
    if (value === 23) {
      return setRoi(8.96),setProfit(206),setEarn(103.50);
    }
    if (value === 24) {
      return setRoi(8.79),setProfit(211),setEarn(105.50);
    }
    if (value === 25) {
      return setRoi(8.64),setProfit(216),setEarn(108.00);
    }
    if (value === 26) {
      return setRoi(8.50),setProfit(221),setEarn(110.50);
    }
    if (value === 27) {
      return setRoi(8.37),setProfit(226),setEarn(113.00);
    }
    if (value === 28) {
      return setRoi(8.25),setProfit(231),setEarn(115.50);
    }
    if (value === 29) {
      return setRoi(8.14),setProfit(236),setEarn(118.50);
    }
    if (value === 30) {
      return setRoi(8.03),setProfit(241),setEarn(120.50);
    }

    // console.log(value, "Value Range");
  }, [value]);
  // console.log("RENDER");
  return (
    <div className="range-slider">
      <h1 className="text-md text-slate-900 font-black">DAYS: {value}</h1>
      <input
        type="range"
        value={sliderVal}
        {...sliderProps}
        className={`slider bg-primary text-primary ${classes}`}
        id="myRange"
        onChange={changeCallback}
        // onMouseDown={() => setMouseState("down")}
        // onMouseUp={() => setMouseState("up")}
      />
       <div>
      <ul role="list" className="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">
          <li  className="col-span-1 flex shadow-sm rounded-md">
            <div className="flex-1 flex items-center justify-between border border-gray-200 bg-white rounded-lg truncate">
              <div className="flex-1 px-4 py-2 text-sm truncate">
                <a  className="text-gray-900 font-medium hover:text-gray-600">
                Daily ROI
                </a>
                <p className="text-gray-500">{roi} %</p>
              </div>
            </div>
          </li>
          <li  className="col-span-1 flex shadow-sm rounded-md">
            <div className="flex-1 flex items-center justify-between border border-gray-200 bg-white rounded-lg truncate">
              <div className="flex-1 px-4 py-2 text-sm truncate">
                <a  className="text-gray-900 font-medium hover:text-gray-600">
                Total Profit
                </a>
                <p className="text-gray-500">{profit} %</p>
              </div>
            </div>
          </li>
          <li  className="col-span-1 flex shadow-sm rounded-md">
            <div className="flex-1 flex items-center justify-between border border-gray-200 bg-white rounded-lg truncate">
              <div className="flex-1 px-4 py-2 text-sm truncate">
                <a  className="text-gray-900 font-medium hover:text-gray-600">
                In {value} Days you will earn
                </a>
                <p className="text-gray-500">{earn} BUSD</p>
              </div>
            </div>
          </li>
      </ul>
    </div>
    </div>
  );
};
